import TextFieldMUI from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import React, {useState} from 'react';

const AutocompleteSelectMultiple = ({
  disabled,
  formikProps,
  label,
  field,
  lookup,
  fullWidth,
  myLabel,
  user,
  id,
  keyForFilter,
  showAll,
  keyForFilterSecond,
}: AutoCompleteSelectMultipleProps) => {
  const [value, setValue] = useState(undefined);

  const lookupData = lookup.find((x) => x.column === field);
  const {touched, errors}: any = formikProps;

  const helperText = touched[field] && errors[field];
  const error = touched[field] && Boolean(errors[field]);

  if (!lookupData) {
    return null;
  }

  let useMyLabel = '';
  if (myLabel !== '#') {
    useMyLabel = myLabel;
  } else {
    useMyLabel = label;
  }

  let array: any[] = lookupData.values;
  //si showAll esta en true, significa que si no se aplico ningun filtro anteriormente muestre datos!
  if (
    formikProps.values[keyForFilter] !== 0 &&
    formikProps.values[keyForFilter] !== ''
  ) {
    array = lookupData.values.filter(
      (x: any) =>
        x[keyForFilter] === formikProps.values[keyForFilter] &&
        x.deleted === false,
    );
  }
  if (
    formikProps.values[keyForFilterSecond] !== 0 &&
    formikProps.values[keyForFilterSecond] !== ''
  ) {
    array = array.filter(
      (x: any) =>
        x['iD_Profile_Web'] === formikProps.values[keyForFilterSecond] &&
        x.deleted === false,
    );
  }

  return (
    <Autocomplete
      multiple
      id="tags-standard"
      options={array}
      getOptionLabel={(option: any) => `${option.name} - ${option.cwid}`}
      value={value}
      onChange={(_: any, value: any) => {
        if (value !== null) {
          formikProps.setFieldValue('employee_Nr', value);
          setValue(value);
        } else {
          formikProps.setFieldValue('employee_Nr', '');
        }
      }}
      renderInput={(params: any) => (
        <TextFieldMUI
          {...params}
          variant="outlined"
          label={useMyLabel}
          required
          fullWidth={fullWidth}
          disabled={disabled}
          error={error}
          helperText={helperText}
        />
      )}
    />
  );
};

interface AutoCompleteSelectMultipleProps {
  //Revisar los any's
  disabled: boolean;
  formikProps: any;
  type: string;
  label: string;
  field: string;
  lookup: any[];
  fullWidth: boolean;
  myLabel: string;
  user: string;
  id: string;
  keyForFilter: string;
  keyForFilterSecond: string;
  showAll: boolean;
}

export default AutocompleteSelectMultiple;
